import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { generatePortalImg } from 'services/generators';

const Image = ({
  src,
  width,
  height,
  alt,
  className,
  onLoad,
  onError,
}) => {
  const computedSrc = useMemo(() => {
    const imgHeight = height || 100;
    const resizedSrc = generatePortalImg({
      src,
      isLocal: src.indexOf('http') === -1,
      height: imgHeight,
      width,
    })
    return resizedSrc;
  }, [height, src, width]);

  return (
    <img
      alt={alt}
      src={computedSrc}
      width={width}
      height={height}
      className={className}
      decoding="async"
      loading="lazy"
      onLoad={onLoad}
      onError={onError}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
};

Image.defaultProps = {
  width: null,
  height: null,
  className: '',
  onLoad: () => null,
  onError: () => null,
};

export default Image;
